'use strict';
(function (w, $, _) {
    
    var context = w.umwAssets['deliveryOptionsController'][0];
    w.deliveryOptionsController = (function () {
        var _self;
        var _missingInputsMsg = 'missingInputs';
        var _undeliverableMsg = 'undeliverable';
        var _settings;
        var _$container;
        var _deliveryAddress = null, _deliveryOptions = null, _deliveryMethodId = null;
        var _$deferredLoad = null;
        var _selectedDeliveryId = null;

        function _createDeferredLoadObj(initiator) {
            const $deferred = $.Deferred();
            $deferred.initiator = initiator;
            $deferred
                .done(function ($deferred, deliveryOptions) {
                    if (!$deferred.isAbandoned) {
                        _onDeliveryOptionsLoaded(deliveryOptions, $deferred.initiator);
                    }
                })
                .fail(function ($deferred, errData) {
                    if ($deferred.isAbandoned) {
                        return;
                    }
                    if (errData.noOptionsAvailable) {
                        _$container.empty().hide();
                        if (typeof _settings.onNoDeliveryOptionAvailable === 'function') {
                            _settings.onNoDeliveryOptionAvailable(errData.message, $deferred.initiator);
                        }
                    }
                });

            return $deferred;
        }

        function _checkAddressAndReloadIfNeeded(address, forceReload, initiator) {
            if (_$deferredLoad) {
                _$deferredLoad.isAbandoned = true;
                _$deferredLoad = null;
            }

            var addressErrorMsg = null;
            if (isRequiredDataMissing(address)) {
                addressErrorMsg = _missingInputsMsg;
            } else if (!address.isDeliverable) {
                addressErrorMsg = _undeliverableMsg;
            }

            if (addressErrorMsg) {
                _selectedDeliveryId = null;
                _$container.empty().hide();
                if (typeof _settings.onNoDeliveryOptionAvailable === 'function') {
                    _settings.onNoDeliveryOptionAvailable(addressErrorMsg, initiator);
                }
            } else if (forceReload || shouldReload(address)) {
                _$deferredLoad = _createDeferredLoadObj(initiator);
                loadDeliveryOptions(address, _$deferredLoad);
            } else {
                _notifyDeliveryOptionSelected(false);
            }

            _deliveryAddress = address;

            function isRequiredDataMissing(address) {
                if (!address) {
                    return true;
                }

                if (!address.countryCode) {
                    return true;
                }
                if (!address.postalCode && context.deliveryDependsOnPostalCode) {
                    return true;
                }

                return false;
            }
            function shouldReload(address) {
                return !_deliveryAddress || address.countryCode !== _deliveryAddress.countryCode || (context.deliveryDependsOnPostalCode && address.postalCode !== _deliveryAddress.postalCode);
            }
            function loadDeliveryOptions(address, $deferred) {
                _$container.empty().hide();

                if (_settings && typeof _settings.blockUi === 'function') {
                    _settings.blockUi();
                }

                var fetchData = {
                    a: "GetDeliveryOptions",
                    PostCode: address.postalCode,
                    CountryCode: address.countryCode,
                };

                $.publicFetch({
                    handler: "EStoreData",
                    data: fetchData,
                    success: function (deliveryOptions) {
                        $(document).trigger('deliveryMethodsLoaded', [deliveryOptions]);
                        if (deliveryOptions && deliveryOptions.length > 0) {
                            $deferred.resolve($deferred, deliveryOptions);
                        } else {
                            $deferred.reject($deferred, { noOptionsAvailable: true });
                        }
                    },
                    error: function (msg, type) {
                        if (type !== 'abort') {
                            if (msg.Code === 140) { //No available delivery options
                                $deferred.reject($deferred, { noOptionsAvailable: true });
                            } else {
                                $deferred.reject($deferred, { noOptionsAvailable: true, message: msg.Message });
                            }
                        }
                    },
                    complete: function () {
                        if (_settings && typeof _settings.unBlockUi === 'function') {
                            _settings.unBlockUi();
                        }
                    }
                });
            }
        }
        function _onDeliveryOptionsLoaded(deliveryOptions, initiator) {
            _deliveryOptions = deliveryOptions;
            if (!deliveryOptions.length) {
                if (typeof _settings.onNoDeliveryOptionAvailable === 'function') {
                    _settings.onNoDeliveryOptionAvailable(null, initiator);
                }
            } else {
                if (typeof _settings.onDeliveryOptionsAvailable === 'function') {
                    _settings.onDeliveryOptionsAvailable();
                }
            }

            var selectedDeliveryChanged, onlyOneDeliveryId = null;

            if (deliveryOptions.length === 1) {
                onlyOneDeliveryId = deliveryOptions[0].deliveryID;

                if (context.hideDeliveryIfOnlyOne) { // will be false if customer can change country
                    _$container.hide();
                    selectedDeliveryChanged = _selectedDeliveryId !== onlyOneDeliveryId;
                    _selectedDeliveryId = onlyOneDeliveryId;

                    _notifyDeliveryOptionSelected(selectedDeliveryChanged);

                    return;
                }
            }

            var data = {
                deliveryOptions: deliveryOptions,
                ControlID: _settings.controlId,
                R: _settings.R
            };

            var deliveryOptionsHtml = _.template(context.template, { data: data });

            _$container.append(deliveryOptionsHtml);
            _$container.show();

            $(".Tooltip", _$container.find('a.DeliveryOption')).tooltip();

            // preSelectDelivery
            var selectedDeliveryId;
            if (onlyOneDeliveryId) {
                uiSelectDeliveryOption(onlyOneDeliveryId);
                selectedDeliveryId = onlyOneDeliveryId;
            } else if (_settings.preferredDeliveryMethodId && uiSelectDeliveryOption(_settings.preferredDeliveryMethodId)) {
                selectedDeliveryId = _settings.preferredDeliveryMethodId;
            } else {
                selectedDeliveryId = null;
            }

            selectedDeliveryChanged = selectedDeliveryId !== _selectedDeliveryId;
            _selectedDeliveryId = selectedDeliveryId;

            addDeliveryChangeListeners();

            _notifyDeliveryOptionSelected(selectedDeliveryChanged);

            function addDeliveryChangeListeners() {
                _$container.find('a.DeliveryOption').click(function (e) {
                    e.preventDefault();

                    _$container.find('a.DeliveryOption').removeClass('selected');
                    $(this).addClass('selected');
                    var selectedDeliveryId = $(this).data('deliveryid');
                    if (typeof selectedDeliveryId === "string") {
                        selectedDeliveryId = parseInt(selectedDeliveryId);
                    }

                    var changed = selectedDeliveryId !== _selectedDeliveryId;
                    _selectedDeliveryId = selectedDeliveryId;

                    _notifyDeliveryOptionSelected(changed);
                });
            };
            function uiSelectDeliveryOption(deliveryId) {
                var options = _$container.find('a.DeliveryOption');
                if (options.length === 0) {
                    return false;
                }
                options.removeClass('selected');
                if (deliveryId < 0) {
                    return false;
                }
                var option = options.filter('[data-deliveryId="' + deliveryId + '"]').first();
                if (option.length === 0) {
                    return false;
                }
                option.addClass('selected');
                return true;
            };
        }
        function _notifyDeliveryOptionSelected(changed) {
            var selectedDelivery = null;
            if (_selectedDeliveryId > -1) {
                selectedDelivery = _.find(_deliveryOptions, function (deliveryOption) {
                    return deliveryOption.deliveryID == _selectedDeliveryId;
                });

                if (!context.hideDeliveryIfOnlyOne && changed) {
                    $(document).trigger('deliveryChanged', [_selectedDeliveryId, selectedDelivery]);

                    var selectedDeliveryName = (selectedDelivery || {}).deliveryName || ('ID#' + _selectedDeliveryId);
                    w.reportDeliveryOptionSelection(_settings.checkoutStepNumber, selectedDeliveryName);
                }
            }
            if (_selectedDeliveryId > -1 && typeof _settings.onDeliveryOptionSelected === 'function') {
                _settings.onDeliveryOptionSelected(selectedDelivery);
            }
        }

        return _self = {
            missingInputsMsg: _missingInputsMsg,
            undeliverableMsg: _undeliverableMsg,

            init: function(settings) {
                settings = $.extend(
                    {
                        $container: null,
                        controlId: null,
                        R: null,
                        checkoutStepNumber: 4,

                        preferredDeliveryMethodId: null, // corresponding delivery option will be pre-selected on first load if available

                        blockUi: function() {}, // used to block UI while delivery methods are being loaded
                        unBlockUi: function () { }, // used to unblock UI after delivery methods loaded
                        onDeliveryOptionsAvailable: function () {},
                        onDeliveryOptionSelected: function(selectedDelivery) {},
                        onNoDeliveryOptionAvailable: function (/*reasonMsg, initiator*/) {} // used to display unavailable delivery error message and disable checkout
                    },
                    settings || {});

                _settings = settings;
                _$container = settings.$container;
            },

            setDeliveryAddress: function(address, initiator) {
                address = $.extend(true, {}, address); // create a copy in case external object changes later
                _checkAddressAndReloadIfNeeded(address, false, initiator);
            },

            reloadDeliveryOptions: function (initiator) { // call when something other than address has changed and can affect delivery availability or price
                _checkAddressAndReloadIfNeeded(_deliveryAddress, true, initiator);
            }
        };
    })();
})(window, jQuery, _);